var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "reviews-leave-btn flex-shrink-0",
      class: { "w-100": _setup.isMobile },
    },
    [
      _c(
        _setup.CorePRG,
        {
          class: { "w-100": _setup.isMobile },
          attrs: {
            url: _setup.newRateUrl,
            "form-attrs": _setup.formAttrs,
            "button-attrs": _setup.buttonAttrs,
          },
        },
        [_vm._v("\n    " + _vm._s(_setup.tStatic("Оставить отзыв")) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }